import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Badge, CartContainer } from '@aimsos/ui';

import NextBestActionActionButton from './NextBestActionActionButton.jsx';

/** One "way to do it" of a suggestion, with its own action; one is marked Recommended (CT-5713). */
const NextBestActionWayCard = memo(function NextBestActionWayCard({ item, way, entity, onAction }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <CartContainer size="S" variant={way.recommended ? 'purple' : 'neutral'}>
      <div data-testid="nba-way" className="flex flex-col gap-2 text-sm">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-medium text-content">{way.title}</span>
          {way.recommended ? (
            <Badge variant="purple" size="small">
              {t('profile.nba.recommended')}
            </Badge>
          ) : null}
        </div>
        {way.description ? <p className="text-content-secondary">{way.description}</p> : null}
        <div>
          <NextBestActionActionButton
            item={item}
            action={way.action}
            variant={way.recommended ? 'primary' : 'secondary'}
            entity={entity}
            onAction={onAction}
          />
        </div>
      </div>
    </CartContainer>
  );
});

export default NextBestActionWayCard;
